import React from 'react';
import CustomersState from './customersState/CustomersState';
import { ListingPage } from 'components/Listing/ListingPage';
import { CustomersControlPanel } from './components/CustomersControlPanel';
import { Customers } from './components/Customers';
import { ModalWindows } from './components/ModalWindows';
import CustomerFullInfoPage from '../CustomerFullInfo';

export const CustomersPageNewUi: React.FC = () => {
	return (
		<CustomersState>
			<ListingPage testId="CustomersPage">
				<CustomersControlPanel />
				<Customers />
				<ModalWindows />
				<CustomerFullInfoPage />
			</ListingPage>
		</CustomersState>
	);
};
